module.exports = __webpack_public_path__ + "static/media/Energy.06423b1c.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Energy.png
// module id = 1746
// module chunks = 1